// removed by extract-text-webpack-plugin
module.exports = {"icon-list":"footer-49T"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/Footer/SocialMedia/social-media.module.scss
// module id = 300
// module chunks = 0